import { useState } from "react";

export function useSettingsFilters() {
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedBrand, setSelectedBrand] = useState<(string | number)[]>([]);
  const [selectedRole, setSelectedRole] = useState("all");
  const [isFilterMenuOpen, setIsFilterMenuOpen] = useState(false);
  const [isFilterMenuAnimating, setIsFilterMenuAnimating] = useState(false);

  const openFilterMenu = () => {
    setIsFilterMenuOpen(true);
    setTimeout(() => setIsFilterMenuAnimating(true), 10);
  };

  const closeFilterMenu = () => {
    setIsFilterMenuAnimating(false);
    setTimeout(() => setIsFilterMenuOpen(false), 300);
  };

  return {
    // States
    searchQuery,
    selectedBrand,
    selectedRole,
    isFilterMenuOpen,
    isFilterMenuAnimating,

    // Setters
    setSearchQuery,
    setSelectedBrand,
    setSelectedRole,

    // Handlers
    openFilterMenu,
    closeFilterMenu,
  };
}
